var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Auth_Screen_LoginSelect'),_c('Auth_Screen_EmailLogin'),_c('Auth_Screen_Registration'),_c('Auth_Screen_RegistrationEmailSent'),_c('Auth_Screen_ForgotPassword')],1)}
var staticRenderFns = []

export { render, staticRenderFns }